import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <p>
        <a
          href="https://github.com/NazM64/weather-app-react"
          target="_blank"
          rel="noreferrer"
          id="GitHub-link"
        >
          Open-Source code
        </a>{" "}
        by Naz Mir
      </p>
    </div>
  );
}
